// extracted by mini-css-extract-plugin
export default {"title_h1":"style_title_h1__ZM8tT","title_h2":"style_title_h2__NCH+q","title_h3":"style_title_h3__aCjuI"};